import React, { useState } from "react";
import styles from "@/styles/mobile/InfoWithImageSection.module.scss";
import DropdownComponent from "../DropdownComponent";
import { InfoWithImageSectionProps } from "@/app/interface/components";
import CustomLink from "../CustomLink";
import ImageComponent from "../ImageComponent";

const InfoWithImageSectionrMobile: React.FC<InfoWithImageSectionProps> = ({
	href,
	hasButton,
	isDropdown,
	title,
	text,
	img,
	contentDropdown,
	flexDirection = "column",
	loading,
	width,
	height,
}) => {
	const [openDropdownIndex, setOpenDropdownIndex] = useState<number | null>(
		null
	);

	const handleDropdownToggle = (index: number) => {
		setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
	};

	return (
		<section className={styles.main} style={{ flexDirection: flexDirection }}>
			<div>
				<h2 className="h2-medium">{title}</h2>
				{isDropdown ? (
					<div>
						{contentDropdown!.map((content, index) => (
							<DropdownComponent
								key={index}
								title={content.title}
								text={content.text}
								isOpen={openDropdownIndex === index}
								onToggle={() => handleDropdownToggle(index)}
							/>
						))}
					</div>
				) : (
					<>
						<p>{text}</p>
						{hasButton && (
							<div className={styles.btn}>
								<CustomLink className="btn-secondary" href={href!}>
									Faça uma cotação
								</CustomLink>
							</div>
						)}
					</>
				)}
			</div>
			<ImageComponent
				src={img}
				alt=""
				loading={loading}
				width={width}
				height={height}
			/>
		</section>
	);
};

export default React.memo(InfoWithImageSectionrMobile);
